import { Assignment } from "@/types/models/Assignment.interface";

export const recordStudentAssignmentView = ({
  isStudent,
  latestAssignment,
  publishedUserAssignments,
  postAssignmentViewRecord,
  recommendedArticleLevelId,
}: {
  isStudent: boolean;
  latestAssignment: Assignment | null;
  publishedUserAssignments: Assignment[];
  postAssignmentViewRecord: Function;
  recommendedArticleLevelId?: string | undefined;
}) => {
  if (!isStudent) return;
  // If latestAssignment is not null (there is an MVE assignment), use that
  // Otherwise, get the latest non-MVE assignment to populate the student view record
  const assignmentWithViewRecord =
    latestAssignment ??
    publishedUserAssignments.sort((a, b) => {
      const bTime = b.date_goes_live ? new Date(b.date_goes_live).getTime() : 0;
      const aTime = a.date_goes_live ? new Date(a.date_goes_live).getTime() : 0;
      return bTime - aTime;
    })[0];
  // Track student assignment view records when an assignment is loaded.
  if (assignmentWithViewRecord?.assignment_id) {
    postAssignmentViewRecord({
      assignment_id: assignmentWithViewRecord.assignment_id,
      ...(recommendedArticleLevelId && {
        recommended_article_level_id: recommendedArticleLevelId,
      }),
    });
  }
};
